import { add } from 'date-fns';

import DateTime from 'components/DateTime';

interface UserLocalTime {
    timezone: number
}

const UserLocalTime = ({ timezone }: UserLocalTime) => {
    return (
        <DateTime format="time">
            { add(new Date(), { minutes: (new Date().getTimezoneOffset() - timezone) }) }
        </DateTime>
    );
}

export default UserLocalTime;
